import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["user"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Avatar from 'flarum/common/components/Avatar';
import classList from 'flarum/common/utils/classList';
import { clampFocus, clampZoom } from '../common/util';

/**
 * When an admin has configured a forum-wide default avatar, render it for any
 * user who has not uploaded one — in place of core's colored letter avatar.
 *
 * The image is positioned purely with CSS (object-position + a clipped zoom
 * transform, exactly mirroring the cover rendering), so it stays a plain
 * presentational fallback: no per-user files are generated and the user's own
 * `avatarUrl()` is left untouched, so avatar-editing UI keeps treating them as
 * "no avatar yet".
 */
export default function applyDefaultAvatar() {
  override(Avatar.prototype, 'view', function (original, vnode) {
    var _app$forum$attribute, _app$forum$attribute2, _app$forum$attribute3;
    const user = vnode.attrs.user;

    // Only step in for a real user who has no avatar of their own.
    const url = user && !user.avatarUrl() ? app.forum.attribute('ziven-profile-cover.default_avatar_url') : null;
    if (!url) return original(vnode);
    const x = clampFocus(Number((_app$forum$attribute = app.forum.attribute('ziven-profile-cover.default_avatar_focus_x')) != null ? _app$forum$attribute : 50));
    const y = clampFocus(Number((_app$forum$attribute2 = app.forum.attribute('ziven-profile-cover.default_avatar_focus_y')) != null ? _app$forum$attribute2 : 50));
    const zoom = clampZoom(Number((_app$forum$attribute3 = app.forum.attribute('ziven-profile-cover.default_avatar_zoom')) != null ? _app$forum$attribute3 : 1));
    const _ref = vnode.attrs,
      _user = _ref.user,
      attrs = _objectWithoutProperties(_ref, _excluded);
    // `loading`/`alt` belong on the <img>, not on the wrapper <span>.
    delete attrs.loading;
    delete attrs.alt;
    const username = user.displayName() || '?';
    if (attrs.title === undefined) attrs.title = username;
    attrs.className = classList('Avatar', 'ProfileCover-defaultAvatar', attrs.className, zoom < 1 && 'ProfileCover-zoomOut');
    attrs.style = _objectSpread(_objectSpread({}, attrs.style && typeof attrs.style === 'object' ? attrs.style : {}), {}, {
      '--da-x': "".concat(x, "%"),
      '--da-y': "".concat(y, "%"),
      '--da-zoom': "".concat(zoom)
    });

    // A wrapper <span> clips the zoom transform: the Avatar is circular via
    // border-radius, and overflow:hidden keeps the scaled image inside it.
    return m("span", attrs, zoom < 1 &&
    // Blurred underlay, visible only when zoomed OUT (< 1×) — the same
    // trick the real cover uses to fill the exposed bands.
    m("img", {
      className: "ProfileCover-defaultAvatar-blur",
      src: url,
      alt: "",
      "aria-hidden": "true",
      draggable: "false"
    }), m("img", {
      className: "ProfileCover-defaultAvatar-image",
      src: url,
      alt: username,
      loading: "lazy",
      draggable: "false"
    }));
  });
}